import { decompressFromEncodedURIComponent } from 'lz-string';

export default function decodeQueryData(input: string) {
  return JSON.parse(decompressFromEncodedURIComponent(input));
}
